import WasmController from "react-lib/frameworks/WasmController";
import * as PlantransferI from "./sequence/PlanTransfer";
import moment from "moment";
import { AxiosError } from "axios";

// APIS
import FoodOrderDetail from "issara-sdk/apis/FoodOrderDetail_apps_FOD";
import IPDContinueDayByEMR from "issara-sdk/apis/IPDContinueDayByEMR_apps_DPI";
import IPDContinueHistory from "issara-sdk/apis/IPDContinueHistory_apps_DPI";
import IPDContinueHistorySerializer_apps_DPI from "issara-sdk/types/IPDContinueHistorySerializer_apps_DPI";
import UserPermissionView from "issara-sdk/apis/UserPermissionView_users";
import PlanItemDetail from "issara-sdk/apis/PlanItemDetail_core";
import IPDOneDayByEMR from "issara-sdk/apis/IPDOneDayByEMR_apps_DPI";
import IPDOneDayByEMRSerializer from "issara-sdk/types/IPDOneDayByEMRSerializer_apps_DPI";
import DoctorOrderCancel from "issara-sdk/apis/DoctorOrderCancel_apps_DPO";
import ProgressionNoteList from "issara-sdk/apis/ProgressionNoteList_apps_DPI";
import FoodOrderIHDetail from "issara-sdk/apis/FoodOrderIHDetail_apps_FOD";
import DrugOrderList from "issara-sdk/apis/DrugOrderList_apps_TPD";

// Serializer
import DrugOrderSerializerForRetrieve from "issara-sdk/types/DrugOrderSerializerForRetrieve_apps_TPD";

// Utils
import { dateToStringWithoutTimeBE, formatADtoBEString } from "react-lib/utils/dateUtils";
import { doc, getDoc, updateDoc, serverTimestamp, setDoc } from "firebase/firestore";
import CONFIG from "config/config";

export type Props = {

}

export type State = {
  errorMessage?: any;
  // Prerequisite
  selectedEncounter?: any | null;
  selectedEmr?: any | null;
  orderSummary?: {
    emr?: number;
    items: any[];
  };
  orderSummaryOneDayAbort?: AbortController;
  orderSummaryAbort?: AbortController;
  orderSummaryOneDay?: IPDOneDayByEMRSerializer;
  filterOrderSummary?: {
    date: moment.Moment;
    nurseStatus: string | null;
    isNurseStatus: boolean;
    isOutPerformDivision: boolean;
    isPharmacy: boolean;
    isTreatmentOrder: boolean;
    isLab: boolean;
    isFood: boolean;
    isNoteOrder: boolean;
    isProcedure: boolean;
    isHD: boolean;
    isImaging: boolean;
  };
  continueHistoryList?: IPDContinueHistorySerializer_apps_DPI | null;
  orderSummaryPermission?: {
    config_BLB_BLOOD_ORDER_DETAIL: string;
    role_DOCTOR: boolean;
  };
  openModSuccessOrderSummary?: {
    open: boolean;
    message: any;
  };
  progressionNoteList?: { activePage?: number; items?: any[]; total?: number; };
  drugOrderList?: DrugOrderSerializerForRetrieve[] | null;
} & PlantransferI.State;

export const StateInitial: State = {
  orderSummary: {
    items: [],
  },
  filterOrderSummary: {
    date: moment(),
    nurseStatus: null,
    isNurseStatus: false,
    isOutPerformDivision: true,
    isPharmacy: true,
    isTreatmentOrder: true,
    isLab: true,
    isFood: true,
    isNoteOrder: true,
    isProcedure: true,
    isHD: true,
    isImaging: true,
  },
  continueHistoryList: null,
  openModSuccessOrderSummary: {
    open: false,
    message: null,
  },
  // ...PlantransferI.StateInitial
};

export type Event =
  // GET
  | { message: "GetIPDOrderSummary"; params: any }
  | { message: "GetIPDContinueHistory"; params: { id: number } }
  | { message: "GetUserPermissionOrderSummary"; params: { id: number } }
  | { message: "GetListProgressionNote"; params: { emrId: number } }
  | { message: "GetDrugOrderListDpi"; params: { emrId: number; date: string; } }
  // UPDATE
  | { message: "HandleUpdatePlanItem"; params: { action: string; allowed_actions: string[] } }
  | { message: "HandleDeleteFoodOrder"; params: { id: number } }
  | { message: "HandleSetContinueHistoryList"; params: { data: any } }
  | { message: "HandleSetOpenModSuccessOrderSummary"; params: { open: boolean } }
  | { message: "HandleSetFilterOrderSummary"; params: { key: string; value: string | boolean } }
  | { message: "UpdateDoctorOrderCancel"; params: { id: number; note: string } }
  | {
      message: "SetIPDOrderSummaryFirebase";
      params: { checked: boolean; orderId: number; labId: number };
    }
  | PlantransferI.Event;

export type Data = {
  division?: number;
};

export const DataInitial = {};

export const PROGRESS_NOTE_LIMIT = 40;

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;

const DATE_FORMAT = "YYYY-MM-DD";

/* ------------------------- GET ------------------------ */
export const GetIPDOrderSummary: Handler = async (controller, params) => {
  const state = controller.getState();

  const filter = state.filterOrderSummary;

  const apiParams = {
    date: dateToStringWithoutTimeBE(filter?.date),
    flag_treatment_order: filter?.isTreatmentOrder,
    flag_note_order: filter?.isNoteOrder,
    flag_out_perform_div: filter?.isOutPerformDivision,
    flag_pharmacy: filter?.isPharmacy,
    flag_lab: filter?.isLab,
    flag_food: filter?.isFood,
    flag_or: filter?.isProcedure,
    flag_hd: filter?.isHD,
    flag_imaging: filter?.isImaging,
    nurse_status: filter?.isNurseStatus ? filter.nurseStatus : "",
  } as any;

  for (const key in apiParams) {
    if (!apiParams[key]) {
      delete apiParams[key];
    }
  }

  await controller.handleEvent({
    message: "GetMasterData" as any,
    params: {
      masters: [
        ["unit", {}],
        ["route", {}],
        ["site", {}],
        ["frequency", {}],
        ["method", {}],
      ],
    },
  });

  GetIPDOrderSummaryContinue(controller, { emrId: state.selectedEmr?.id, ...apiParams });
  GetIPDOrderSummaryOneDay(controller, { emrId: state.selectedEmr?.id, ...apiParams });
};

export const SetIPDOrderSummaryFirebase: Handler = async (controller, params) => {

  let state = controller.getState();
  let items = state.orderSummaryOneDay?.items ? [...state.orderSummaryOneDay?.items] : []
  let idx = items.findIndex((i: any) => i.id === params.orderId);
  console.log('idx: ', idx);

  if (idx !== -1) {
    items[idx] = {
      ...items[idx],
      orderSummaryFirebase: {
        ...items[idx].orderSummaryFirebase,
        [params.labId]: { loading: true }
      },
    };

    console.log('items: ', items);
    controller.setState({
      orderSummaryOneDay: {
        ...state.orderSummaryOneDay,
        items: items,
      },
    });
  } else {
    console.error("can't find element")
    return
  }

  const docRef = doc(controller.db, "OrderSummary", params.orderId.toString());
  const docSnap = await getDoc(docRef);
  state = controller.getState();
  if (docSnap.exists()) {

    let a = await updateDoc(doc(controller.db, "OrderSummary", params.orderId.toString()), {
      [params.labId]: { checked: params.checked , editBy: state?.userId, edited: serverTimestamp(), divisionId: state.selectedDivision?.id, divisionNameCode: state.selectedDivision?.name_code}
    }).catch((error) => console.error(error))

  } else {
    console.log("createDoc")
    let a = await setDoc(doc(controller.db, "OrderSummary", params.orderId.toString()), {
      [params.labId]: { checked: params.checked, editBy: state?.userId, edited: serverTimestamp(), created: serverTimestamp()}
    }).catch((error) => console.error(error))

  }

  state = controller.getState();

  items = state.orderSummaryOneDay?.items ? [...state.orderSummaryOneDay?.items] : []
  idx = items.findIndex((i: any) => i.id === params.orderId);

  if (idx !== -1) {
    items[idx] = {
      ...items[idx],
      orderSummaryFirebase: {
        ...items[idx].orderSummaryFirebase,
        [params.labId]: { checked: params.checked, loading: false}
      },
    };

    console.log('items: ', items);
    controller.setState({
      orderSummaryOneDay: {
        ...state.orderSummaryOneDay,
        items: items,
      },
    });
  }
};

export const GetIPDOrderSummaryContinue: Handler = async (controller, params) => {
  const state = controller.getState();

  state.orderSummaryAbort?.abort();

  const abortCtrl = new AbortController();

  controller.setState({ orderSummaryAbort: abortCtrl });

  const orderSummary = await IPDContinueDayByEMR.retrieve({
    pk: params.emrId,
    params: {
      date: params.date,
      flag_treatment_order: params.flag_treatment_order,
      flag_note_order: params.flag_note_order,
      flag_out_perform_div: params.flag_out_perform_div,
      flag_pharmacy: params.flag_pharmacy,
      flag_lab: params.flag_lab,
      flag_food: params.flag_food,
      flag_or: params.flag_or,
      flag_hd: params.flag_hd,
      nurse_status: params.nurse_status,
    },
    apiToken: controller.apiToken,
    extra: {
      signal: abortCtrl.signal,
    },
  });

  if (orderSummary[2].code === AxiosError.ERR_CANCELED) {
    return;
  }

  if (orderSummary[1]) {
    controller.setState({
      orderSummary: undefined,
    });
  } else {
    let items = orderSummary[0]?.items || [];
    // for (const [index, item] of items?.entries()) {
    //   const docRef = doc(controller.db, "OrderSummary", item.id.toString());
    //   const docSnap = await getDoc(docRef);
    //     if (docSnap.exists()) {
    //       console.log("Document data:", docSnap.data());
    //       items[index].orderSummaryFirebase = docSnap.data()
    //     } else {
    //       // docSnap.data() will be undefined in this case
    //       console.log("No such document!");
    //       items[index].orderSummaryFirebase = {}
    //     }
    // }
    controller.setState({
      orderSummary: { ...orderSummary[0], items },
    });
  }
};

// Add Firebase 68288
export const GetIPDOrderSummaryOneDay: Handler = async (controller, params) => {
  const state = controller.getState();

  state.orderSummaryOneDayAbort?.abort();

  const abortCtrl = new AbortController();

  controller.setState({ orderSummaryOneDayAbort: abortCtrl });

  const orderSummary = await IPDOneDayByEMR.retrieve({
    pk: params.emrId,
    params: {
      date: params.date,
      flag_treatment_order: params.flag_treatment_order,
      flag_note_order: params.flag_note_order,
      flag_out_perform_div: params.flag_out_perform_div,
      flag_pharmacy: params.flag_pharmacy,
      flag_lab: params.flag_lab,
      flag_food: params.flag_food,
      flag_or: params.flag_or,
      flag_hd: params.flag_hd,
      flag_imaging: params.flag_imaging,
      nurse_status: params.nurse_status,
    },
    apiToken: controller.apiToken,
    extra: {
      signal: abortCtrl.signal,
    },
  });

  if (orderSummary[2].code === AxiosError.ERR_CANCELED) {
    return;
  }

  // const docRef = doc(controller.db, "OrderSummary", );
  // const docSnap = await getDoc(docRef);
  if (orderSummary[1]) {
    controller.setState({
      orderSummaryOneDay: undefined,
    });
  } else {
    const items = orderSummary[0]?.items || [];

    try {
      for (const [index, item] of items?.entries()) {
        const docRef = doc(controller.db, "OrderSummary", item.id.toString());
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data());
          items[index].orderSummaryFirebase = docSnap.data();
        } else {
          // docSnap.data() will be undefined in this case
          console.log("No such document!");
          items[index].orderSummaryFirebase = {};
        }
      }
    } catch (error) {
      console.error("Error getting document:", error);
    }

    controller.setState({
      orderSummaryOneDay: { ...orderSummary[0], items },
    });
  }

  console.log("GetIPDOrderSummaryOneDay: ", orderSummary);
  controller.setState({
    orderSummaryOneDay: orderSummary[0],
  });
};

export const GetUserPermissionOrderSummary: Handler = async (controller, params) => {
  const permission = await UserPermissionView.post({
    apiToken: controller.apiToken,
    data: {
      config_BLB_BLOOD_ORDER_DETAIL: "",
      role_DOCTOR: false,
      role_REGISTERED_NURSE: false,
    },
  });

  controller.setState({
    orderSummaryPermission: permission[0] || {},
  });
};

export const GetIPDContinueHistory: Handler = async (controller, params) => {
  const continueHistory = await IPDContinueHistory.retrieve({
    pk: params.id,
    apiToken: controller.apiToken,
  });

  controller.setState({
    continueHistoryList: continueHistory[0],
  });
};

export const GetDrugOrderListDpi: Handler = async (controller, params) => {
  const date = formatADtoBEString(params.date?.format(DATE_FORMAT));

  const drugOrderList = await DrugOrderList.list({
    apiToken: controller.apiToken,
    params: {
      date,
      emr: params?.emrId,
    },
  });

  params?.onCallBack(false,true)

  controller.setState({
      drugOrderList: drugOrderList[0],
  });
};

/* ----------------------- UPDATE ----------------------- */
export const HandleUpdatePlanItem: Handler = async (controller, params) => {
  const response = await PlanItemDetail.update({
    pk: params.id,
    apiToken: controller.apiToken,
    data: {
      action: params.action,
      allowed_actions: params.allowed_actions,
      note: params.note || "",
      user_token: "",
      end_time: params.end_time,
      end_date: params.end_date,
    },
  });

  if (!response[1]) {
    // #70216 ถ้าเป็น FoodOrder ของ CU ต้องการ OFF ต้อง OFF รายการที่เป็น Pending ด้วย
    if (CONFIG.COMPANY === "CU" && params.item.type === "foodorder" && params.action === "OFF") {
      const actualOrders = params.item?.plan_item?.actual_orders;
      const lastActualOrders =
        actualOrders.length > 0 ? actualOrders[actualOrders.length - 1] : null;
      if (lastActualOrders) {
        const [respAction, errAction, netwAction] = await FoodOrderDetail.delete({
          pk: lastActualOrders,
          extra: { division: controller.data.division },
          apiToken: controller.apiToken,
        });
      }
    }
    HandleSetOpenModSuccessOrderSummary(controller, { open: true });
  }

  GetIPDOrderSummary(controller, params);
};

export const HandleDeleteFoodOrder: Handler = async (controller, params) => {
  const response = await FoodOrderIHDetail.delete({
    pk: params.id,
    apiToken: controller.apiToken,
   });

  if (!response[1]) {
    HandleSetOpenModSuccessOrderSummary(controller, { open: true });
  }

  GetIPDOrderSummary(controller, params);
};

const PutDoctorOrderCancel: Handler = async (controller, params) => {
  const response = await DoctorOrderCancel.put({
    pk: params.id,
    data: {
      action: "CANCEL",
      note: params.note,
    },
    apiToken: controller.apiToken,
    extra: {
      division: controller.data.division,
    },
  });

  return response;
};

export const UpdateDoctorOrderCancel: Handler = async (controller, params) => {
  const response = await PutDoctorOrderCancel(controller, params);

  if (!response[1]) {
    HandleSetOpenModSuccessOrderSummary(controller, { open: true, message: "ยกเลิกสำเร็จ" });
  }

  GetIPDOrderSummary(controller, params);
};

/* ------------------------- SET ------------------------ */
export const HandleSetContinueHistoryList: Handler = (controller, params) => {
  controller.setState({
    continueHistoryList: params.data,
  });
};

export const HandleSetOpenModSuccessOrderSummary: Handler = (controller, params) => {
  controller.setState({ openModSuccessOrderSummary: params });
};

export const HandleSetFilterOrderSummary: Handler = (controller, params) => {
  const state = controller.getState();

  controller.setState(
    {
      filterOrderSummary: {
        ...(state.filterOrderSummary as any),
        [params.key]: params.value,
      },
    },
    () => {
      GetIPDOrderSummary(controller, {});
    }
  );

  controller.handleEvent({
    message: "HandleNurseOrderPerformed" as any,
    params: { action: "select_all", isChecked: false },
  });
};

export const GetListProgressionNote: Handler = async (controller, params) => {
  const activePage = params.activePage || 1;
  const offset = (activePage - 1) * PROGRESS_NOTE_LIMIT;

  const result = await ProgressionNoteList.list({
    apiToken: controller.apiToken,
    params: {
      emr: params.emrId,
      limit: PROGRESS_NOTE_LIMIT,
      offset,
      sort: "menu",
    },
  });

  controller.setState({
    progressionNoteList: {
      activePage,
      items: result[0]?.items || [],
      total: result[0]?.total || 0,
    },
  });
};
